import { Bell } from "lucide-react";
import { useEffect } from "react";
import { Link } from "react-router";

import { useNoticeCount } from "./api";

export function NotificationBell({ enabled }: { enabled: boolean }) {
  const count = useNoticeCount(enabled);
  const unread = count.data?.unread_count ?? 0;

  useEffect(() => {
    if (!enabled || !("setAppBadge" in navigator)) return;
    const app = navigator as Navigator & { setAppBadge: (count: number) => Promise<void>; clearAppBadge?: () => Promise<void> };
    const update = unread ? app.setAppBadge(unread) : app.clearAppBadge?.();
    if (update) void update.catch(() => {});
  }, [enabled, unread]);

  if (!enabled) return null;
  return <Link to="/avisos" aria-label={`Avisos${unread ? ` · ${unread} sin leer` : ""}`} className="relative inline-flex min-h-11 items-center gap-2 rounded-lg border border-line px-3 text-sm font-semibold text-ink hover:bg-surface-2">
    <Bell size={17} aria-hidden />
    <span className="hidden sm:inline">Avisos</span>
    {unread > 0 ? <span className="inline-grid min-w-5 place-items-center rounded-full bg-workspace-accent px-1.5 py-0.5 text-[10px] leading-none text-workspace-accent-ink">{unread > 99 ? "99+" : unread}</span> : null}
  </Link>;
}
